import { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { apiClient, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const NAVY = "#132a63";
const GREEN = "#16a34a";

export default function RegistroAfiliado() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const invite = params.get("invite") || "";
  const [f, setF] = useState({ nombre: "", email: "", celular: "", password: "", tipo: "afiliado", redes: "", nicho: "medico", seguidores: "10k-25k" });
  const [loading, setLoading] = useState(false);
  const [invited, setInvited] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  useEffect(() => {
    if (!invite) return;
    apiClient.get(`/outreach/invite/${invite}`).then(({ data }) => {
      setF((prev) => ({
        ...prev,
        nombre: data.nombre || prev.nombre,
        email: data.email || prev.email,
        redes: data.redes || prev.redes,
        nicho: data.nicho || prev.nicho,
        seguidores: data.seguidores || prev.seguidores,
        tipo: data.tipo || "influencer",
      }));
      setInvited(true);
    }).catch(() => {});
  }, [invite]);

  const submit = async (e) => {
    e.preventDefault();
    const cel = f.celular.replace(/\D/g, "");
    if (!f.nombre || !f.email || cel.length < 10 || f.password.length < 6) {
      toast.error("Completa todos los campos (contraseña mínima 6 caracteres).");
      return;
    }
    setLoading(true);
    try {
      await apiClient.post("/afiliados/register", { ...f, celular: cel, invite_token: invite || undefined });
      await refresh();
      toast.success("¡Bienvenido al programa de socios!");
      navigate("/socios");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "No se pudo crear tu cuenta.");
    } finally { setLoading(false); }
  };

  return (
    <div style={wrap}>
      <Helmet><title>Únete como Socio — Mi Ángel Asís</title></Helmet>
      <div style={card} data-testid="afiliado-registro-card">
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>Programa de Socios</div>
          <p style={{ color: "#6b7280", marginTop: 4, fontSize: 14 }}>Gana comisiones recomendando Mi Ángel Asís 💚</p>
          {invited && (
            <div data-testid="invite-banner" style={{ background: "#ecfdf5", border: `1px solid ${GREEN}`, color: "#065f46", borderRadius: 10, padding: "8px 12px", fontSize: 13, marginTop: 10 }}>
              🎉 ¡Te invitamos personalmente! Tus datos ya están precargados, solo crea tu contraseña.
            </div>
          )}
        </div>
        <form onSubmit={submit}>
          <label style={lbl}>Nombre completo</label>
          <input style={inp} value={f.nombre} onChange={set("nombre")} data-testid="af-nombre" />
          <label style={lbl}>Email</label>
          <input style={inp} type="email" value={f.email} onChange={set("email")} data-testid="af-email" />
          <label style={lbl}>Celular (WhatsApp)</label>
          <input style={inp} inputMode="numeric" value={f.celular} onChange={set("celular")} placeholder="55 1234 5678" data-testid="af-celular" />
          <label style={lbl}>Contraseña</label>
          <input style={inp} type="password" value={f.password} onChange={set("password")} data-testid="af-password" />
          <label style={lbl}>¿Cómo promocionarás?</label>
          <select style={inp} value={f.tipo} onChange={set("tipo")} data-testid="af-tipo">
            <option value="afiliado">Afiliado (links, SEO, ads)</option>
            <option value="influencer">Influencer (redes sociales)</option>
          </select>
          <label style={lbl}>Tu nicho de contenido</label>
          <select style={inp} value={f.nicho} onChange={set("nicho")} data-testid="af-nicho">
            <option value="legal">Legal / Abogacía</option>
            <option value="gruas">Grúas / Autos / Vial</option>
            <option value="medico">Salud / Atención médica</option>
            <option value="otro">Otro</option>
          </select>
          <label style={lbl}>¿Cuántos seguidores tienes?</label>
          <select style={inp} value={f.seguidores} onChange={set("seguidores")} data-testid="af-seguidores">
            <option value="<10k">Menos de 10,000</option>
            <option value="10k-25k">10,000 – 25,000</option>
            <option value="25k-50k">25,000 – 50,000</option>
            <option value="50k-100k">50,000 – 100,000</option>
            <option value="+100k">Más de 100,000</option>
          </select>
          <label style={lbl}>Tus redes / sitio (opcional)</label>
          <input style={inp} value={f.redes} onChange={set("redes")} placeholder="@usuario, tiktok.com/@..." data-testid="af-redes" />
          <button type="submit" disabled={loading} data-testid="af-submit"
            style={{ ...btn, background: GREEN, color: "white", marginTop: 18, opacity: loading ? 0.7 : 1 }}>
            {loading ? "Creando cuenta…" : "Crear mi cuenta de socio"}
          </button>
        </form>
        <div style={{ textAlign: "center", marginTop: 14 }}>
          <Link to="/socios/login" style={{ color: NAVY, fontSize: 13, fontWeight: 600 }} data-testid="af-go-login">¿Ya eres socio? Inicia sesión</Link>
        </div>
      </div>
    </div>
  );
}

const wrap = { minHeight: "100vh", background: NAVY, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Poppins',system-ui,sans-serif" };
const card = { background: "white", color: "#1f2937", borderRadius: 22, padding: "30px 26px", maxWidth: 440, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" };
const lbl = { display: "block", fontSize: 12, fontWeight: 700, color: NAVY, marginTop: 12, marginBottom: 4 };
const inp = { width: "100%", padding: "11px 13px", borderRadius: 10, border: "1px solid #cbd5e1", fontSize: 15, fontFamily: "inherit", boxSizing: "border-box" };
const btn = { width: "100%", padding: "13px", borderRadius: 999, fontWeight: 800, border: "none", cursor: "pointer", fontSize: 15, fontFamily: "inherit" };
